goog.provide('el8.appservice.tabControl');

goog.require('el8.service.urls');

/**
 * Trigger auto-restoration of existing tabs after [re]login.
 */

el8.appservice.tabControl = (function() {
    /**
     * All pages get a broadcast 'tabControlChannel' to manage tabs.
     */
    var tabControlChannel = new window.BroadcastChannel('tabControl');

    return {
        listenForRestoreTabMessage: function() {
            /**
             * Respond to 'restoreTab' messages. 
             * Only active on the login page.
             */
            tabControlChannel.onmessage = function(event) {
                if (event.data === 'restoreTab') {
                    /**
                     * Restore browser tab to the URL contained in the 'next'
                     * querystring param. If there is no 'next' param, send
                     * the user to the practice home.
                     */
                    var queryString = window.location.search;
                    var urlParams = new window.URLSearchParams(queryString);
                    var nextPath = urlParams.get('next');
                    if (nextPath) {
                        window.location.href = decodeURI(nextPath);
                    } else {
                        window.location.href = el8.service.urls.get('goToPracticeHome');
                    }
                }
            }     
        },

        issueRestoreTabMessage: function() {
            /**
             * Issue 'restoreTab' messages. 
             */
            tabControlChannel.postMessage('restoreTab');
        },
    }
})();